module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.userHasAccess) ? _c('div', [(_vm.user.membership_status === 'CANCELED') ? _c('Alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your coverage plan was cancelled. If you'd like to re-enable your coverage, ")]), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Re-enable my plan"
    }
  }, [_vm._v("please contact our billing team.")])]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'UNPAID') ? _c('Alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your coverage plan is currently unpaid. Please proceed to "), _c('router-link', {
    staticClass: "color-theme",
    attrs: {
      "to": "/account/dashboard"
    }
  }, [_vm._v("Account Settings")]), _vm._v(" to resolve or ")], 1), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Re-enable my plan"
    }
  }, [_vm._v("contact our billing team")]), _vm._v(".\n  ")]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'PAST_DUE') ? _c('Alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your coverage plan is currently past due. Please proceed to "), _c('router-link', {
    staticClass: "color-theme",
    attrs: {
      "to": "/account/dashboard"
    }
  }, [_vm._v("Account Settings")]), _vm._v(" to resolve or ")], 1), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Re-enable my plan"
    }
  }, [_vm._v("contact our billing team")]), _vm._v(".\n  ")]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'BANNED') ? _c('Alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your account has been banned. If you think this was done in error, ")]), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Inquiry Regarding Banned Account"
    }
  }, [_vm._v("please contact our billing team.")])]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'INACTIVE') ? _c('Alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your coverage plan was cancelled. If you'd like to re-enable your coverage, ")]), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Re-enable my plan"
    }
  }, [_vm._v("please contact our billing team.")])]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'INVALID_USER') ? _c('Alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your account has been marked as invalid by our system due to unpaid premiums or other account issues. If you think this was done in error, ")]), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Re-enable my plan"
    }
  }, [_vm._v("please contact our billing team.")])]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d7f23be","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/notifications.vue
// module id = 1280
// module chunks = 0